<template>
    <div class="content">
        <div class="box_top">
            <div class="el-icon-s-home">当前位置：</div>
            <el-breadcrumb separator=">>">
                <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>{{dataList.mname}}</el-breadcrumb-item>
                <el-breadcrumb-item>{{dataList.cname}}</el-breadcrumb-item>
                <el-breadcrumb-item>正文</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div>
            <div class="article_title">{{dataList.title}}</div>
            <div class="article_title_bottom">
                <span>作者：{{dataList.author}}</span>&nbsp;&nbsp;
                <span>日期：{{dataList.created_time}}</span>&nbsp;&nbsp;
                <span>点击率：{{dataList.visit}}</span>
            </div>
            <div style="borderBottom: 1px solid #edebea;"></div>
            <div v-html="dataList.content" class="abc"></div>
            <div class="fujianBox" v-if="dataList.files_json">
                <div class="fujianText">附件：</div>
                <div class="fujianTextBox">
                    <div v-for="(item,index) in dataList.files_json" :key="index" @click="fujianBtn(item)">
                        {{ item.name }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            dataList:{},
            // 传过来的id值
            cid:''
        }
    },
    created(){
        // 从地址栏中拿到传过来的id值
        this.cid=this.$route.query.id
        this.getDataList()
    },
    methods:{
        async getDataList(){
            const {data:res}=await this.$http.get(`article/detail?id=${this.cid}`)
            if(res.code==200){
                res.data.files_json=JSON.parse(res.data.files_json)
                this.dataList=res.data
            }
        },
        fujianBtn(item){
            // window.location.href=item.url
            window.open(item.url)
            // // 通过设置a标签来实现下载功能

            // // 创建blob、的本地url
            // let binaryData=[]
            // binaryData.push(item)
            // let blobURL=window.URL.createObjectURL(new Blob(binaryData))
            // // 创建a标签
            // let link = document .createElement("a")
            // // 设置href
            // link.href=blobURL
            // // 设置download
            // link.download=item.name
            // link.style.display="none"
            // link.click()
        }
    }
}
</script>

<style lang="less" scoped>
.box_top{
    height: 46px;
    border-bottom: 1px solid #edebea;
    margin-top: 15px;
    line-height: 46px;
    display: flex;
    align-items: center;
    div{
        font-size: 14px;
        color: #666;
    }
    .el-breadcrumb{
        margin-left: 10px;
        font-size: 14px;
        color: #666;
    }
}
.article_title{
    width: 100%;
    text-align: center;
    font-size: 35px;
    font-weight: bold;
    margin: 25px 0;
}
.article_title_bottom{
    width: 100%;
    // text-align: center;
    display: flex;
    justify-content: space-around;
    font-size: 14px;
    color: #333333;
    margin-bottom: 25px;
}
.fujianBox{
    height: 30px;
    display: flex;
    align-items: center;
    // background-color: red;
    margin-top: 10px;
    margin-bottom: 10px;
    margin-right: 10px;
    .fujianText{
        text-indent: 2em;
    }
    .fujianTextBox{
        color: #55b9de;
        cursor: pointer;
    }
}
::v-deep img{
    max-width: 100%;
    max-height: 100%;
}
::v-deep table {
  border-top: 1px solid #ccc;
  border-left: 1px solid #ccc;
}
::v-deep table td,
::v-deep table th {
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
  padding: 3px 5px;
}
::v-deep table th {
//   border-bottom: 2px solid #ccc;
  text-align: center;
}
::v-deep iframe{
    width: 100%;
    height: 600px;
}
</style>